import { TorneoListaBuenaFe, TorneoListaBuenaFeJSON } from '../TorneoListaBuenaFe/TorneoListaBuenaFe';
import { Entrenador, EntrenadorJSON } from '../Entrenador/Entrenador';
export interface TorneoListaBuenaFeOficialJSON {
  tlbfo_id: string;
  tlbfo_tlbfid: string;
  tlbfo_entid: string;
  torneoListaBuenaFe: TorneoListaBuenaFeJSON | null;
  entrenador: EntrenadorJSON | null;
}

export class TorneoListaBuenaFeOficial {
  protected constructor(
    private id: string,
    private tlbfid: string,
    private entid: string,
    private torneoListaBuenaFe: TorneoListaBuenaFe | null,
    private entrenador: Entrenador | null
  ) {}

  static createFrom(
    id: string,
    tlbfid: string,
    entid: string,
    torneoListaBuenaFe: TorneoListaBuenaFe | null,
    entrenador: Entrenador | null
  ) {
    return new this(id, tlbfid, entid, torneoListaBuenaFe, entrenador);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: TorneoListaBuenaFeOficial) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: TorneoListaBuenaFeOficialJSON) {
    return TorneoListaBuenaFeOficial.createFrom(
      entity.tlbfo_id,
      entity.tlbfo_tlbfid,
      entity.tlbfo_entid,
      entity.torneoListaBuenaFe ? TorneoListaBuenaFe.fromJSON(entity.torneoListaBuenaFe) : null,
      entity.entrenador ? Entrenador.fromJSON(entity.entrenador) : null
    );
  }

  toJSON(): TorneoListaBuenaFeOficialJSON {
    return {
      tlbfo_id: this.getId(),
      tlbfo_tlbfid: this.getTlbfid(),
      tlbfo_entid: this.getEntid(),
      torneoListaBuenaFe: null,
      entrenador: null,
    };
  }

  getId(): string {
    return this.id;
  }

  getTlbfid(): string {
    return this.tlbfid;
  }

  getEntid(): string {
    return this.entid;
  }

  getTorneoListaBuenaFe(): TorneoListaBuenaFe | null {
    return this.torneoListaBuenaFe;
  }
  getEntrenador(): Entrenador | null {
    return this.entrenador;
  }
}
